import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { Trigger, Header } from '@radix-ui/react-accordion';

import { cn } from '@discover-lib/utils';

export type AccordionTriggerProps = ComponentPropsWithoutRef<typeof Trigger> &
  DataAttributeProps & {
    headerClassName?: string;
  };

const AccordionTrigger = forwardRef<ElementRef<typeof Trigger>, AccordionTriggerProps>(
  ({ className, children, headerClassName, ...props }, ref) => (
    <Header className={cn('flex', headerClassName)}>
      <Trigger
        ref={ref}
        className={cn(
          'flex flex-1 items-center justify-between py-2 font-medium transition-all [&[data-state=open]>svg]:rotate-180',
          className
        )}
        {...props}>
        {children}
      </Trigger>
    </Header>
  )
);

AccordionTrigger.displayName = Trigger.displayName;

export default AccordionTrigger;
